import PropTypes from 'prop-types';
import React from 'react';
// import ReactModal from 'react-modal';
import Draggable from 'react-draggable';
import bindAll from 'lodash.bindall';
import {connect} from 'react-redux';
import styles from './modal.css';
import BoardImg from './handpy-board.png';
import Empty from './empty.png';
import {handpyBoardButtonAction, closeHandpySimModal} from '../../reducers/modals';


class ModalComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleModalSizeChange',
            'onMouseDownA',
            'onMouseUpA',
            'onMouseDownB',
            'onMouseUpB',
            'onMouseDownP',
            'onMouseUpP',
            'onMouseDownY',
            'onMouseUpY',
            'onMouseDownT',
            'onMouseUpT',
            'onMouseDownH',
            'onMouseUpH',
            'onMouseDownO',
            'onMouseUpO',
            'onMouseDownN',
            'onMouseUpN',
            'handleDrag',
            'handleStart',
            'handleStop'
        ]);

        this.state = {
            isLarge: false,
            posX: 0, // (window.innerWidth / 2) - 275,
            posY: 0, // (window.innerHeight / 2) - 187
            // bounds: 'parent', // {left: 0, top: 5, right: 5, bottom: 5}
        };
    }
    // 数据处理
    componentWillReceiveProps (nextProps) {

    }

    onStart () {}
    onStop () {}
    
    handleStart (e, data){
        // console.log(this.movingBox);
        // console.log(e);
        // console.log(data.x, '-', data.deltaX, '-', data.lastX);
        // {
        //     node: HTMLElement,
        //     // lastX + deltaX === x
        //     x: number, y: number,
        //     deltaX: number, deltaY: number,
        //     lastX: number, lastY: number
        // }
    }
    handleDrag (e, data){
        // console.log(JSON.stringify(this.movingBox.state));
        // console.log(this.movingBox.props.x, '-', this.movingBox.props.deltaX, '-', this.movingBox.props.lastX);
        // console.log(e);
        // console.log(data.x, '-', data.deltaX, '-', data.lastX);
        // console.log(this.movingBox.state.x, '--', this.movingBox.state.y);
        // if (Math.abs(this.movingBox.state.x) <= 10 && Math.abs(this.movingBox.state.y) <= 10) {
        //     this.movingBox.state.x = 0;
        //     this.movingBox.state.y = 0;
        // }
    }
    handleStop (e, data){
        // console.log(JSON.stringify(this.movingBox.state));
        // console.log(e);
        // console.log(data.x, '-', data.deltaX, '-', data.lastX);
        // console.log(this.movingBox.state.x, '--', this.movingBox.state.y);
        if (Math.abs(this.movingBox.state.x) <= 50 && Math.abs(this.movingBox.state.y) <= 50) {
            this.movingBox.state.x = 0;
            this.movingBox.state.y = 0;
        }
    }
    // 缩放功能
    handleModalSizeChange () {
        this.setState({
            isLarge: !this.state.isLarge
        });
    }

    onMouseDownA () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {A: 'down'}
        });
    }
    onMouseUpA () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {A: 'up'}
        });
    }
    onMouseDownB () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {B: 'down'}
        });
    }
    onMouseUpB () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {B: 'up'}
        });
    }
    onMouseDownP () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {P: 'down'}
        });
    }
    onMouseUpP () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {P: 'up'}
        });
    }
    onMouseDownY () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {Y: 'down'}
        });
    }
    onMouseUpY () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {Y: 'up'}
        });
    }
    onMouseDownT () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {T: 'down'}
        });
    }
    onMouseUpT () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {T: 'up'}
        });
    }
    onMouseDownH () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {H: 'down'}
        });
    }
    onMouseUpH () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {H: 'up'}
        });
    }
    onMouseDownO () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {O: 'down'}
        });
    }
    onMouseUpO () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {O: 'up'}
        });
    }
    onMouseDownN () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {N: 'down'}
        });
    }
    onMouseUpN () {
        this.props.handpyBoardButtonAction({
            timestamp: new Date().getTime(),
            data: {N: 'up'}
        });
    }
    
    render () {
        const {
            handpyBoardScreenLine1, handpyBoardScreenLine2, handpyBoardScreenLine3, handpyBoardScreenLine4,
            closeHandpySimModal
        } = this.props;
        const {
            posX, posY
        } = this.state;

        return (
            <div className="draggable_box">
                <Draggable
                    onStart={this.handleStart}
                    onDrag={this.handleDrag}
                    onStop={this.handleStop}
                    defaultPosition={{x: posX, y: posY}}
                    ref={el => {
                        this.movingBox = el;
                    }}
                >
                    <div className={styles.modalMobileChart} >
                        
                        <span
                            className={styles.closeModal}
                            onClick={closeHandpySimModal}
                        >×</span>

                        <div className={styles.boardImgBox} >
                            <img
                                className={styles.boardImg}
                                draggable={false}
                                src={BoardImg}
                            />
                            <div className={styles.boardImgButtons}>
                                <span
                                    className={styles.boardImgButtonA}
                                    onMouseDown={this.onMouseDownA}
                                    onTouchStart={this.onMouseDownA}
                                    onMouseUp={this.onMouseUpA}
                                    onTouchCancel={this.onMouseUpA}
                                > </span>
                                <span
                                    className={styles.boardImgButtonB}
                                    onMouseDown={this.onMouseDownB}
                                    onTouchStart={this.onMouseDownB}
                                    onMouseUp={this.onMouseUpB}
                                    onTouchCancel={this.onMouseUpB}
                                > </span>
                            </div>
                            <div className={styles.boardImgScreen}>
                                <p className={styles.boardImgP1}>
                                    {handpyBoardScreenLine1}
                                </p>
                                <p className={styles.boardImgP2}>
                                    {handpyBoardScreenLine2}
                                </p>
                                <p className={styles.boardImgP3}>
                                    {handpyBoardScreenLine3}
                                </p>
                                <p className={styles.boardImgP4}>
                                    {handpyBoardScreenLine4}
                                </p>
                            </div>
                            <div className={styles.boardImgTouches}>
                                <span
                                    className={styles.boardImgTouchP}
                                    onMouseDown={this.onMouseDownP}
                                    onTouchStart={this.onMouseDownP}
                                    onMouseUp={this.onMouseUpP}
                                    onTouchCancel={this.onMouseUpP}
                                > </span>
                                <span
                                    className={styles.boardImgTouchY}
                                    onMouseDown={this.onMouseDownY}
                                    onTouchStart={this.onMouseDownY}
                                    onMouseUp={this.onMouseUpY}
                                    onTouchCancel={this.onMouseUpY}
                                > </span>
                                <span
                                    className={styles.boardImgTouchT}
                                    onMouseDown={this.onMouseDownT}
                                    onTouchStart={this.onMouseDownT}
                                    onMouseUp={this.onMouseUpT}
                                    onTouchCancel={this.onMouseUpT}
                                > </span>
                                <span
                                    className={styles.boardImgTouchH}
                                    onMouseDown={this.onMouseDownH}
                                    onTouchStart={this.onMouseDownH}
                                    onMouseUp={this.onMouseUpH}
                                    onTouchCancel={this.onMouseUpH}
                                > </span>
                                <span
                                    className={styles.boardImgTouchO}
                                    onMouseDown={this.onMouseDownO}
                                    onTouchStart={this.onMouseDownO}
                                    onMouseUp={this.onMouseUpO}
                                    onTouchCancel={this.onMouseUpO}
                                > </span>
                                <span
                                    className={styles.boardImgTouchN}
                                    onMouseDown={this.onMouseDownN}
                                    onTouchStart={this.onMouseDownN}
                                    onMouseUp={this.onMouseUpN}
                                    onTouchCancel={this.onMouseUpN}
                                > </span>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        );
    }
}


ModalComponent.propTypes = {
    onRequestClose: PropTypes.func,
    handpyBoardButtonAction: PropTypes.func,
    handpyBoardScreenLine1: PropTypes.string,
    handpyBoardScreenLine2: PropTypes.string,
    handpyBoardScreenLine3: PropTypes.string,
    handpyBoardScreenLine4: PropTypes.string,
    closeHandpySimModal: PropTypes.func
    // tags: PropTypes.arrayOf(PropTypes.shape(TagButton.propTypes)),
    // title: PropTypes.string.isRequired
}
const mapStateToProps = state => ({
    handpyBoardScreenLine1: state.scratchGui.modals.HANDPY_BOARD_SCREEN_1,
    handpyBoardScreenLine2: state.scratchGui.modals.HANDPY_BOARD_SCREEN_2,
    handpyBoardScreenLine3: state.scratchGui.modals.HANDPY_BOARD_SCREEN_3,
    handpyBoardScreenLine4: state.scratchGui.modals.HANDPY_BOARD_SCREEN_4
    
});

const mapDispatchToProps = dispatch => ({
    handpyBoardButtonAction: data => dispatch(handpyBoardButtonAction(data)),
    closeHandpySimModal: () => dispatch(closeHandpySimModal())
});

export default connect(
    mapStateToProps,
    // mapDispatchToProps
    mapDispatchToProps
)(ModalComponent);

